"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_router_1 = __importDefault(require("vue-router"));
var Start_vue_1 = __importDefault(require("../components/app/Start.vue"));
var NotFound_vue_1 = __importDefault(require("../components/app/NotFound.vue"));
var ThankYou_vue_1 = __importDefault(require("../components/app/ThankYou.vue"));
var Login_vue_1 = __importDefault(require("../components/app/Login.vue"));
var Welcome_vue_1 = __importDefault(require("../components/app/Welcome.vue"));
var PaymentComplete_vue_1 = __importDefault(require("../components/app/PaymentComplete.vue"));
vue_1.default.use(vue_router_1.default);
var routes = [
    {
        path: '/',
        component: Welcome_vue_1.default
    },
    {
        path: '/login',
        component: Login_vue_1.default
    },
    {
        path: '/payment/complete',
        component: PaymentComplete_vue_1.default,
    },
    {
        path: '/application',
        component: Start_vue_1.default
    },
    {
        path: '/thank_you',
        component: ThankYou_vue_1.default,
    },
    {
        path: '*',
        component: NotFound_vue_1.default
    }
];
exports.default = new vue_router_1.default({
    routes: routes,
    mode: 'history'
});
